import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CallEventsTable = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    const fetchCallLogs = async () => {
      try {
        const response = await axios.get('https://stagedialer.clay.in/api/calllog/call-events');
        const data = response.data;
        console.log("API response:", data);
        const logsArray = Array.isArray(data) ? data : data.data || [];
        setLogs(logsArray);
        setFilteredLogs(logsArray);
      } catch (error) {
        console.error('Error fetching call logs:', error);
        setLogs([]);
        setFilteredLogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCallLogs();
  }, []);

  // Filter handler
  const handleFilterChange = (e) => {
    const value = e.target.value.toLowerCase();
    setFilter(value);
    const filtered = logs.filter(log =>
      log.event?.toLowerCase().includes(value)
    );
    setFilteredLogs(filtered);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
          <span className="text-gray-600 text-lg font-medium">Loading call logs...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-700">Call Events</h2>
        <input
          type="text"
          value={filter}
          onChange={handleFilterChange}
          placeholder="Filter by Event Type"
          className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
        />
      </div>

      <div className="overflow-x-auto shadow rounded-lg border border-gray-200">
        <table className="min-w-full bg-white">
          <thead>
            <tr className="bg-gray-100 text-gray-700 text-sm uppercase text-left">
              <th className="py-2 px-4 border-b">ID</th>
              <th className="py-2 px-4 border-b">Call ID</th>
              <th className="py-2 px-4 border-b">Message</th>
              <th className="py-2 px-4 border-b">Event Type</th>
              <th className="py-2 px-4 border-b">User</th>
              <th className="py-2 px-4 border-b">From Number</th>
              <th className="py-2 px-4 border-b">To Number</th>
              <th className="py-2 px-4 border-b">Result</th>
              <th className="py-2 px-4 border-b">Reason</th>
              <th className="py-2 px-4 border-b">User</th>
              <th className="py-2 px-4 border-b">User Rate</th>
              <th className="py-2 px-4 border-b">Timestamp</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 text-sm">
            {filteredLogs.length === 0 ? (
              <tr>
                <td colSpan="12" className="text-center py-4 text-gray-500">No matching records found.</td>
              </tr>
            ) : (
              filteredLogs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b">{log.id}</td>
                  <td className="py-2 px-4 border-b">{log.callid}</td>
                  <td className="py-2 px-4 border-b">Message</td>
                  <td className="py-2 px-4 border-b">{log.event}</td>
                  <td className="py-2 px-4 border-b">{log.from}</td>
                  <td className="py-2 px-4 border-b">{log.from_number || '-'}</td>
                  <td className="py-2 px-4 border-b">{log.to_endpoint}</td>
                  <td className="py-2 px-4 border-b">{log.result || '-'}</td>
                  <td className="py-2 px-4 border-b">{log.reason || '-'}</td>
                  <td className="py-2 px-4 border-b">{log.user}</td>
                  <td className="py-2 px-4 border-b">{log.raw_payload?.userRate?.amount ?? '-'}</td>
                  <td className="py-2 px-4 border-b">{log.raw_payload?.timestamp}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CallEventsTable;
